<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h2>The Changing of the Guard</h2>
        </b-col>

        <b-col cols="10" offset="1">
          <p class="mt-3 text-justify">
            &emsp;The traditional ceremony of the old guard changing with the new.
          </p>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp1.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="10" offset="1" class="mt-3">
          <p class="mt-3 text-justify">
            &emsp;Changing of the Guard is one of the oldest and most recognizable ceremonies connected with Buckingham Palace. The correct name of the ceremony known as Changing the Guard is actually Guard Mounting. In this process a New Guard exchanges duty with the Old Guard and both Guards are drawn from one of the regiments of Foot Guards
          </p>
        </b-col>

        <b-col cols="5" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp2.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="5" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp3.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="10" offset="1" class="mt-5">
          <h4>A few interesting facts about the Palace Guards</h4>
          <p class="mt-3 text-justify">
            &emsp;The traditional ceremony of the old guard changing with the new.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The standard bearskin hat of the British Foot Guards is 18 inches tall, weighs one and a half pounds and is made from the fur of the Canadian black bear.
          </p>
          <p class="mt-3 text-justify">
            &emsp;In the Guards museum there is a bearskin hat you can try on for size. It also has uniforms and medals on display and a history of the foot guards.
          </p>
          <p class="mt-3 text-justify">
            &emsp;If you would like your picture taken with a Guard, At St James' Palace, walk all the way past the courtyard at the Palace and turn round the corner, you are now in Pall Mall at this spot there is a guard standing all on his own. Simply go and stand next to him and pass your friend the camera.
          </p>
          <p class="mt-3 text-justify">
            &emsp;If you’re confused as to which regiment a palace guard is from simply observe the colour of the plume, and the side on which it is worn on the bearskin. Also note the button spacing, the collar badge and the shoulder badge. When all five regiments parade together, they are in the following order; Grenadier Guards on the right flank, then Scots Guards, Welsh Guards, Irish Guards and Coldstream Guards on the left flank.
          </p>
        </b-col>

        <b-col cols="10" offset="1" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp4.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="10" offset="1" class="mt-3">
          <h4>The Queens Guard</h4>
          <p class="mt-3 text-justify">
            &emsp;The Guard which mounts at Buckingham Palace is called The Queen’s Guard and is divided into two Detachments: the Buckingham Palace Detachment (which is responsible for guarding Buckingham Palace), and the St. James’s Palace Detachment, (which guards St. James’s Palace).
          </p>
          <p class="mt-3 text-justify">
            &emsp;These guard duties are normally provided by a battalion of the Household Division and occasionally by other infantry battalions or other units. When Guardsmen are on duty, the soldiers are drawn from one of the five regiments of Foot
          </p>
          <p class="mt-3 text-justify">
            &emsp;Guards in the British Army: the Scots Guards, the Irish Guards, the Welsh Guards, the Grenadier Guards and the Coldstream Guards.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The Queen’s Guard is commanded by a Captain (who usually holds the rank of Major), and each Detachment is commanded by a Lieutenant. The Colour of the Battalion providing the Guard is carried by a Second Lieutenant who is known as the Ensign.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The handover is also accompanied by a Guards band. The music played ranges from traditional military marches to songs from films and musicals and even familiar pop songs.
          </p>

          <p class="mt-3 text-justify" style="font-size: 14px;">
            <i>
              Source: <a href="https://buckinghampalace.co.uk/changing-the-guard/">https://buckinghampalace.co.uk/changing-the-guard/</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12">
          <h4>The Changing of the Guard</h4>
        </b-col>

        <b-col cols="12">
          <p class="mt-3 text-justify">
            &emsp;The traditional ceremony of the old guard changing with the new.
          </p>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp1.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="12" class="mt-3">
          <p class="mt-3 text-justify">
            &emsp;Changing of the Guard is one of the oldest and most recognizable ceremonies connected with Buckingham Palace. The correct name of the ceremony known as Changing the Guard is actually Guard Mounting. In this process a New Guard exchanges duty with the Old Guard and both Guards are drawn from one of the regiments of Foot Guards
          </p>
        </b-col>

        <b-col cols="12" class="mt-2 text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp2.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>
        <b-col cols="12" class="mt-2 text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp3.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="12" class="mt-3">
          <h5>A few interesting facts about the Palace Guards</h5>
          <p class="mt-3 text-justify">
            &emsp;The traditional ceremony of the old guard changing with the new.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The standard bearskin hat of the British Foot Guards is 18 inches tall, weighs one and a half pounds and is made from the fur of the Canadian black bear.
          </p>
          <p class="mt-3 text-justify">
            &emsp;In the Guards museum there is a bearskin hat you can try on for size. It also has uniforms and medals on display and a history of the foot guards.
          </p>
          <p class="mt-3 text-justify">
            &emsp;If you would like your picture taken with a Guard, At St James' Palace, walk all the way past the courtyard at the Palace and turn round the corner, you are now in Pall Mall at this spot there is a guard standing all on his own. Simply go and stand next to him and pass your friend the camera.
          </p>
          <p class="mt-3 text-justify">
            &emsp;If you’re confused as to which regiment a palace guard is from simply observe the colour of the plume, and the side on which it is worn on the bearskin. Also note the button spacing, the collar badge and the shoulder badge. When all five regiments parade together, they are in the following order; Grenadier Guards on the right flank, then Scots Guards, Welsh Guards, Irish Guards and Coldstream Guards on the left flank.
          </p>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-img
            :src="require('@/assets/img/articles/1911263/bp4.jpg')"
            fluid
            class="content-picture"
          />
        </b-col>

        <b-col cols="12" class="mt-3">
          <h5>The Queens Guard</h5>
          <p class="mt-3 text-justify">
            &emsp;The Guard which mounts at Buckingham Palace is called The Queen’s Guard and is divided into two Detachments: the Buckingham Palace Detachment (which is responsible for guarding Buckingham Palace), and the St. James’s Palace Detachment, (which guards St. James’s Palace).
          </p>
          <p class="mt-3 text-justify">
            &emsp;These guard duties are normally provided by a battalion of the Household Division and occasionally by other infantry battalions or other units. When Guardsmen are on duty, the soldiers are drawn from one of the five regiments of Foot
          </p>
          <p class="mt-3 text-justify">
            &emsp;Guards in the British Army: the Scots Guards, the Irish Guards, the Welsh Guards, the Grenadier Guards and the Coldstream Guards.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The Queen’s Guard is commanded by a Captain (who usually holds the rank of Major), and each Detachment is commanded by a Lieutenant. The Colour of the Battalion providing the Guard is carried by a Second Lieutenant who is known as the Ensign.
          </p>
          <p class="mt-3 text-justify">
            &emsp;The handover is also accompanied by a Guards band. The music played ranges from traditional military marches to songs from films and musicals and even familiar pop songs.
          </p>

          <p class="mt-3 text-justify" style="font-size: 14px;">
            <i>
              Source: <a href="https://buckinghampalace.co.uk/changing-the-guard/">https://buckinghampalace.co.uk/changing-the-guard/</a>
            </i>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191126-the-changing-of-the-guard',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191126-the-changing-of-the-guard.vue